module.exports = __webpack_public_path__ + "img/Close.71a9b4a3.svg";